export { default } from "ember-basic-dropdown/modifiers/basic-dropdown-trigger";
